import { createAction } from 'redux-act';

import Place from '../../../models/interfaces/Place';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchPlacePayload extends FetchPayload {
  placeUuid: string;
}
export const fetchPlace = createAction<FetchPlacePayload>('FETCH_PLACE');

export interface PlaceFetchedPayload extends TimestampPayload {
  place: Place;
}
export const placeFetched = createAction<PlaceFetchedPayload>('PLACE_FETCHED');

export interface PlaceFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const placeFetchFailed = createAction<PlaceFetchFailedPayload>('PLACE_FETCH_FAILED');
